import { Directive, effect, ElementRef, HostListener, inject, input } from '@angular/core';

@Directive({
  selector: '[appTwoDigitDecimalNumber]',
  standalone: false,
})
export class TwoDigitDecimaNumberDirective {
  readonly noDecimal = input<number>(10);

  regex: RegExp = new RegExp(/^\d*\.?\d{0,2}$/g);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

  // Use inject() instead of constructor parameter injection — aligns with project DI convention
  private readonly el = inject(ElementRef);

  constructor() {
    // Replaces both ngOnInit and ngOnChanges: effect fires immediately (init) and on every
    // noDecimal change, keeping the regex in sync with the signal input.
    effect(() => {
      this.setRegex();
    });
  }

  setRegex() {
    const noDecimal = this.noDecimal();
    if (noDecimal === 0 || !noDecimal) {
      this.regex = new RegExp(/^[\d]*$/g);
    } else if (noDecimal === 6) {
      this.regex = new RegExp(/^\d*\.?\d{0,6}$/g);
    } else if (noDecimal === 10) {
      this.regex = new RegExp(/^\d*\.?\d{0,10}$/g);
    }
  }

  @HostListener('paste', ['$event']) onPaste($event: ClipboardEvent) {
    return false;
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    let current: string = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart;
    const next: string = [current.slice(0, position), event.key == 'Decimal' ? '.' : event.key, current.slice(position)].join('');
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}
